import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4;

import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { H4 } from 'UIComponents/elements/headings';
import UIImage from 'UIComponents/image/UIImage';
import BestValueBadge from '../common/BestValueBadge';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints'; // @ts-expect-error svg import

import BLOB from 'bender-url!pricing-pages-ui/img/splash-page/suite-card-top-right-blob.svg';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import UIButton from 'UIComponents/button/UIButton';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { useHistory } from 'react-router-dom';
import { STARTER_SUITE_CARD } from '../../constants/tracking/Locations';
import { StarterCrmSuiteBOTranslationKeys } from '../../constants/BusinessObjectivesTranslationKeys';
import ChecklistItem from '../common/ChecklistItem';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import { CrmSuitePrice } from '../merch-card/price-display/CrmSuitePrice';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { useValidatedCrmSuiteQueryParamTerm } from '../../utils/urls/queryParamUtils';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import SuiteTermSelectorContainer from '../merch-card/SuiteTermSelectorContainer';
import SuiteTileCTAsContainer from '../merch-card/SuiteTileCTAsContainer';
const StyledCardWrapper = styled(UICardWrapper).withConfig({
  displayName: "StarterCrmSuiteCtaCard__StyledCardWrapper",
  componentId: "xtic9l-0"
})(["display:grid;grid-template-columns:2fr 1fr;grid-template-areas:'header cta' 'content cta' 'content cta';width:100%;padding:32px 24px;border:1px solid ", ";min-height:150px;text-align:left;margin:auto;position:relative;overflow:hidden;", ";", ";"], BATTLESHIP, breakpoint.tablet(_t || (_t = _`
    min-width: 0;
    &&& {
      margin: 0 auto;
    }

    grid-template-columns: 1fr;
    grid-template-areas:
      "header"
      "content"
      "cta";
  `)), breakpoint.tabletPortrait(_t2 || (_t2 = _`
    width: 94%;
  `)));
export const StyledBlob = styled(UIImage).withConfig({
  displayName: "StarterCrmSuiteCtaCard__StyledBlob",
  componentId: "xtic9l-1"
})(["position:absolute;top:-1px;right:-1px;"]);
const StyledBestValueBadge = styled(BestValueBadge).withConfig({
  displayName: "StarterCrmSuiteCtaCard__StyledBestValueBadge",
  componentId: "xtic9l-2"
})(["position:absolute;z-index:1;top:12px;right:12px;"]);
const CardHeader = styled.div.withConfig({
  displayName: "StarterCrmSuiteCtaCard__CardHeader",
  componentId: "xtic9l-3"
})(["grid-area:header;z-index:2;"]);
const ContentContainer = styled.div.withConfig({
  displayName: "StarterCrmSuiteCtaCard__ContentContainer",
  componentId: "xtic9l-4"
})(["grid-area:content;display:flex;flex-direction:column;justify-content:space-between;"]);
const CTAsContainer = styled.div.withConfig({
  displayName: "StarterCrmSuiteCtaCard__CTAsContainer",
  componentId: "xtic9l-5"
})(["grid-area:cta;justify-self:center;display:flex;flex-direction:column;justify-content:center;align-items:stretch;height:100%;max-width:350px;width:100%;text-align:center;z-index:2;button,a{width:100%;line-height:25px;}div:first-child{margin-top:0 !important;}", " ", ""], breakpoint.tablet(_t3 || (_t3 = _`
    justify-content: flex-start;
    margin-top: 32px;
  `)), breakpoint.phoneLarge(_t4 || (_t4 = _`
    max-width: 100%;
  `)));

const StarterCrmSuiteCtaCard = ({
  productLine
}) => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const history = useHistory();
  const {
    queryParamTerm,
    setQueryParamTerm
  } = useValidatedCrmSuiteQueryParamTerm({
    productLevel: STARTER
  });
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);

  const handleExploreClick = () => {
    const url = isAppAuth ? '/suite' : '/suite/starter';
    getUsageTracker().track('internalLinkClick', {
      name: 'explore-link',
      url,
      trackingSource: STARTER_SUITE_CARD
    });
    window.scrollTo(0, 0);
    history.push(url);
  };

  return /*#__PURE__*/_jsxs(StyledCardWrapper, {
    className: "m-top-5",
    children: [/*#__PURE__*/_jsx(StyledBlob, {
      src: BLOB
    }), /*#__PURE__*/_jsx(StyledBestValueBadge, {}), /*#__PURE__*/_jsxs(CardHeader, {
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "splash-page.bundles.STARTER.title"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "splash-page.bundles.STARTER.description"
        })
      })]
    }), /*#__PURE__*/_jsxs(ContentContainer, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "splash-page.bundles.starterCrmSuiteCard.idealFor"
      }), StarterCrmSuiteBOTranslationKeys.map(bizObjectiveText => /*#__PURE__*/_jsx(ChecklistItem, {
        message: bizObjectiveText
      }, bizObjectiveText))]
    }), /*#__PURE__*/_jsxs(CTAsContainer, {
      children: [/*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !hasPricingAndPurchasingSucceeded,
        heights: [16, 23, 16],
        widths: [60, 70, 130],
        className: "flex-column align-end",
        Content: CrmSuitePrice,
        contentProps: {
          productLevel: STARTER,
          termOverride: queryParamTerm,
          wrapperStyle: {
            textAlign: 'center'
          }
        }
      }), /*#__PURE__*/_jsx("div", {
        className: "m-y-3",
        children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
          isLoading: !hasPricingAndPurchasingSucceeded,
          heights: [41],
          Content: SuiteTermSelectorContainer,
          contentProps: {
            productLevel: STARTER,
            onChange: newTerm => {
              setQueryParamTerm(newTerm);
            },
            queryParamTerm,
            trackingSource: STARTER_SUITE_CARD
          }
        })
      }), /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !hasPricingAndPurchasingSucceeded,
        heights: [47],
        className: "m-bottom-7",
        children: /*#__PURE__*/_jsx(SuiteTileCTAsContainer, {
          productLevel: STARTER,
          trackingSource: STARTER_SUITE_CARD,
          sourceId: `pricing-${productLine.toLowerCase()}-page-starter-suite-card`,
          hubsSignupProductOverride: "suitestarter"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "m-top-4",
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "link",
          onClick: handleExploreClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "splash-page.explore"
          })
        })
      })]
    })]
  });
};

export default StarterCrmSuiteCtaCard;